import gsap from 'gsap'
import { CustomEase } from "../vendor/gsap-bonus-umd/CustomEase";
gsap.registerPlugin(CustomEase);

const easesCustom = {
  "cubic":CustomEase.create("customCubic", "M0,0 C0.84,0 0.16,1 1,1"),
  "quart":CustomEase.create("customQuart", "M0,0 C0.76,0 0.24,1 1,1"),
}

export default easesCustom;
